import {Russian} from 'flatpickr/dist/l10n/ru.js';

const initFlatpickr = () => {
  return flatpickr('[data-input="date"]', {
    dateFormat: 'd.m.Y',
    minDate: 'today',
    maxDate: new Date().fp_incr(360),
    disableMobile: true,
    locale: Russian,
  });
};

export {initFlatpickr};
